import React from 'react';
export const StatusPill = (props) => {
    const { label, status } = props;
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        React.createElement("div", { style: {
                width: '10px',
                height: '10px',
                backgroundColor: status ? '#0F9D58' : '#E94B3C',
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '15px'
            } }),
        React.createElement("div", { style: {
                fontSize: '12px',
                fontWeight: '500',
                fontFamily: 'Barlow',
                color: '#5F6368'
            } }, label)));
};
